import { v4 as uuidv4 } from "uuid";
import { EventDataMessageType, RatingItemType } from "@app/pippa/models";

export enum ActionTypes {
  CLOSE_WIDGET_WITH_CONFIRMATION = "CLOSE_WIDGET_WITH_CONFIRMATION",
}

export enum MessageTypes {
  INTRO = "intro",
  TEXT = "text",
  TYPING = "TYPING",
}

export enum ButtonTypes {
  POSTBACK = "postback",
  WEB_URL = "web_url",
  RATING = "rating",
}

export enum ChatActionTypes {
  CONVERSATION_START = "CONVERSATION_START",
}

export enum AttributeNames {
  QUICK_REPLY_TYPE = "quick_reply_type",
  UPDATE_MESSAGES = "updateMessages",
}

export enum AttributeValues {
  TRUE = "true",
  FALSE = "false",
  PRIMARY = "PRIMARY",
  SECONDARY = "secondary",
}

export enum KeyTypes {
  ENTER = "enter",
  ESCAPE = "escape",
  TAB = "tab",
  SPACE = " ",
}

export enum FeedbackTypes {
  CSAT = "CSAT",
}

export enum MessageReaction {
  THUMBS_UP = "THUMBS_UP",
  THUMBS_DOWN = "THUMBS_DOWN",
  CLEARED = "CLEARED",
}

export const MAX_MESSAGE_FEEDBACK_LENGTH = 1000;

export const introMessage = {
  type: "intro",
  id: uuidv4(),
} as EventDataMessageType;

export const ratingItems = [
  {
    scoreNumber: 1,
    title: "1",
    ariaLabel: "Score 1",
  },
  {
    scoreNumber: 2,
    title: "2",
    ariaLabel: "Score 2",
  },
  {
    scoreNumber: 3,
    title: "3",
    ariaLabel: "Score 3",
  },
  {
    scoreNumber: 4,
    title: "4",
    ariaLabel: "Score 4",
  },
  {
    scoreNumber: 5,
    title: "5",
    ariaLabel: "Score 5",
  },
] as RatingItemType[];

export const EMPTY_RATING: RatingItemType = {
  scoreNumber: -1,
  ariaLabel: "",
  title: "",
};

export const npsScoreItems = [
  {
    scoreNumber: 0,
    title: "0",
    ariaLabel: "Score 0",
  },
  {
    scoreNumber: 1,
    title: "1",
    ariaLabel: "Score 1",
  },
  {
    scoreNumber: 2,
    title: "2",
    ariaLabel: "Score 2",
  },
  {
    scoreNumber: 3,
    title: "3",
    ariaLabel: "Score 3",
  },
  {
    scoreNumber: 4,
    title: "4",
    ariaLabel: "Score 4",
  },
  {
    scoreNumber: 5,
    title: "5",
    ariaLabel: "Score 5",
  },
  {
    scoreNumber: 6,
    title: "6",
    ariaLabel: "Score 6",
  },
  {
    scoreNumber: 7,
    title: "7",
    ariaLabel: "Score 7",
  },
  {
    scoreNumber: 8,
    title: "8",
    ariaLabel: "Score 8",
  },
  {
    scoreNumber: 9,
    title: "9",
    ariaLabel: "Score 9",
  },
  {
    scoreNumber: 10,
    title: "10",
    ariaLabel: "Score 10",
  },
] as RatingItemType[];

export const SANITIZE_OPTIONS = {
  ADD_ATTR: ["activity-event"],
};
